import { Ajax2 } from '@shared/Ajax';


function fetchPrivileges(): Promise<IPrivilege[]> {
    return Ajax2({
        url: kuura.getIamAddress() + '/privileges',
        useToken: true
    }).then((unsorted: IPrivilege[]) => {
        return unsorted.sort((a, b) => {
            if (a.area === b.area) return a.rank - b.rank;
            return a.area - b.area;
        });
    });
}

function fetchRoles(organizationUuid: string): Promise<IUserRole[]> {
    return Ajax2({
        url: kuura.getIamAddress() + '/roles',
        useToken: true,
        data: {
            organizationUuid
        }
    }).then(roles => {
        roles.forEach(role => {
            role.privileges = (role.privileges || []).map(p => p.name);
        });
        return roles;
    });
}

function createRole(organizationUuid: string, name: string): Promise<void> {
    return Ajax2({
        url: kuura.getIamAddress() + '/role',
        method: 'post',
        useToken: true,
        contentType: 'json',
        data: {
            organizationUuid,
            name
        },
    });
}

function renameRole(roleUuid: string, name: string): Promise<void> {
    return Ajax2({
        url: kuura.getIamAddress() + '/role/' + roleUuid,
        useToken: true,
        method: 'patch',
        contentType: 'json',
        data: [
            { op: 'replace', path: '/name', value: name },
        ],
    });
}

function updateRolePrivileges(roleUuid: string, privileges: { name: string }[]): Promise<void> {
    return Ajax2({
        url: kuura.getIamAddress() + '/role/' + roleUuid,
        useToken: true,
        method: 'patch',
        contentType: 'json',
        data: [
            { op: 'replace', path: '/privileges', value: privileges },
        ],
    });
}

function deleteRole(role: IUserRole): Promise<void>  {
    return Ajax2({
        url: kuura.getIamAddress() + '/role/' + role.uuid,
        useToken: true,
        method: 'delete'
    });
}

export const UserRoleService = {
    fetchRoles,
    fetchPrivileges,
    createRole,
    renameRole,
    updateRolePrivileges,
    deleteRole
};

